<template>
  <div>
    <p v-if="RetMsg">出现错误：{{RetMsg}}</p>
  </div>
</template>

<script>
export default {
  name: 'HubAuthorize',
  data() {
    return {
      RetMsg: ''
    }
  },
  computed: {
    openId() {
      return this.$route.query.openId;
    },
    accessToken() {
      return this.$route.query.accessToken;
    }
  },
  created() {
    let lastPath = sessionStorage.getItem('lastPath');
    if(this.openId && this.accessToken) {
      if(sessionStorage.getItem("scope") == 'snsapi_base') {
        this.getUserInfo();
      } else {
        if(lastPath == '/newProduct') {
          this.getUnionId();
        } else {
          this.getAuthInfo();
        }
      }
    } else {
      if(lastPath == '/newProduct') {
        sessionStorage.setItem("scope", 'snsapi_userinfo');
        this.getAuthCode('snsapi_userinfo');
      } else {
        sessionStorage.setItem("scope", 'snsapi_base');
        this.getAuthCode('snsapi_base');
      }
    }
  },
  methods: {
    getUserInfo() {
      this.$axios.post('/Api/Api/Web/Customer/GetENUInfo?openid=' + this.openId).then(res => {
        if (res.RetCode == '10000') {
          let data = res.Data;
          if(data.auto) {
            if(data.user) {
              sessionStorage.setItem("userInfo", JSON.stringify(data.user));
              this.$router.replace('/home');
            } else {
              sessionStorage.setItem("AuthInfo", JSON.stringify(data.auto));
              this.$router.replace('/EnglishRegister');
            }
          } else {
            sessionStorage.setItem("scope", 'snsapi_userinfo');
            this.getAuthCode('snsapi_userinfo');
          }
        } else {
          this.RetMsg = res.RetMsg;
          this.$toast(res.RetMsg);
        }
      })
    },
    getAuthInfo() {
      this.$axios.post('/Api/Api_Hub/GetUserInfo', {
        openid: this.openId,
        access_token: this.accessToken
      }).then(res => {
        if (res.RetCode == '10000') {
          if (res.Data) {
            this.getUserInfo();
          }
        } else {
          this.RetMsg = res.RetMsg;
          this.$toast(res.RetMsg);
        }
      })
    },
    getUnionId() {
      this.$axios.post('/Api/Api_Hub/GetUnionid', {
        openid: this.openId,
        access_token: this.accessToken
      }).then(res => {
        if (res.RetCode == '10000') {
          if (res.Data) {
            sessionStorage.setItem('unionid', res.Data);
            let lastPath = sessionStorage.getItem('lastPath');
            this.$router.replace(lastPath);
          }
        } else {
          this.RetMsg = res.RetMsg;
          this.$toast(res.RetMsg);
        }
      })
    },
    getAuthCode(scope) {
      // 术韵 wx0ff34443bc889aba
      // 强生视界 wxc8567b9f90662acd
      location.href =`${process.env.VUE_APP_HUB_URL}?appId=${process.env.VUE_APP_APPID}&scope=${scope}&returnUrl=${encodeURIComponent(process.env.VUE_APP_REDIRECT_URL)}`
    }
  }
}
</script>